<template>
  <div class="cny" :class="cssType">
    <Banner />
    <AppLang class="app-lang" type="act-cny" />
    <ValidateUser />
    <Lottery />
    <Rewards />
    <Rule />
    <AppFooter />
    <ActFloat />
    <LotteryRewardDialog v-model="state.lotteryRewardDialog.visible" :data="state.lotteryRewardDialog.data" :cb="state.lotteryRewardDialog.cb" />
    <RewardDialog v-model="state.rewardDialog.visible" :data="state.rewardDialog.data" :cb="state.rewardDialog.cb" />
    <RewardRecordDialog v-model="state.rewardRecordDialog.visible" :data="state.rewardRecordDialog.data" :cb="state.rewardRecordDialog.cb" />
    <LotteryRecordDialog v-model="state.lotteryRecordDialog.visible" :data="state.lotteryRecordDialog.data" :cb="state.lotteryRecordDialog.cb" />
    <ActTimeDialog v-model="state.actTimeDialog.visible" :data="state.actTimeDialog.data" :cb="state.actTimeDialog.cb" />
  </div>
</template>

<script setup>
import { reactive, provide, watch, onMounted, onUnmounted } from 'vue'
import Banner from './components/Banner'
import AppLang from '@/components/AppLang'
import ValidateUser from '@/components/ValidateUser/ActCny'
import Rewards from './components/Rewards'
import Rule from './components/Rule'
import AppFooter from '@/components/AppFooter'
import ActFloat from './components/ActFloat'
import Lottery from './components/Lottery'
import { useLog } from '@/composables/useLog'
import { isMobile } from '@/utils'
import LotteryRewardDialog from './components/Dialog/LotteryRewardDialog'
import RewardDialog from './components/Dialog/RewardDialog'
import RewardRecordDialog from './components/Dialog/RewardRecordDialog'
import LotteryRecordDialog from './components/Dialog/LotteryRecordDialog'
import ActTimeDialog from './components/Dialog/ActTimeDialog'
import CnyActApi from '@/config/cnyActApi'
import { useStore } from 'vuex'
import { LOGIN_REWARD } from './const'
const store = useStore()
const log = useLog()
try {
  log.track('act_cny_page_entry', {
    referrer: document.referrer
  })
} catch (error) {
  console.error(error)
}
const cssType = isMobile ? 'mobile' : 'pc'
const state = reactive({
  dialogOpen: 0,
  lotteryRewardDialog: {
    visible: false,
    data: {},
    cb: null
  },
  rewardDialog: {
    visible: false,
    data: {},
    cb: null
  },
  rewardRecordDialog: {
    visible: false,
    data: {},
    cb: null
  },
  lotteryRecordDialog: {
    visible: false,
    data: {},
    cb: null
  },
  actTimeDialog: {
    visible: false,
    data: {
      type: 'ended', // not-start, ended
    },
    cb: null
  }
})

const globalConfig = reactive({
  totalLotteryCount: 0, // 总抽奖次数
  usedLotteryCount: 0, // 已用抽奖次数
  displayList: [], // 抽奖列表
  accumulateRewardList: [], // 累抽奖励列表
  accumulateRewardedList: [], // 已领取累抽奖励列表
})

provide('globalConfig', globalConfig)

const toggleLotteryRewardDialog = (visible, data, cb) => {
  state.lotteryRewardDialog.visible = visible
  state.lotteryRewardDialog.data = data
  state.lotteryRewardDialog.cb = cb
}
const toggleRewardDialog = (visible, data, cb) => {
  state.rewardDialog.visible = visible
  state.rewardDialog.data = data
  state.rewardDialog.cb = cb
}
const toggleRewardRecordDialog = (visible, data, cb) => {
  state.rewardRecordDialog.visible = visible
  state.rewardRecordDialog.data = data
  state.rewardRecordDialog.cb = cb
}

const toggleLotteryRecordDialog = (visible, data, cb) => {
  state.lotteryRecordDialog.visible = visible
  state.lotteryRecordDialog.data = data
  state.lotteryRecordDialog.cb = cb
}

provide('toggleLotteryRewardDialog', toggleLotteryRewardDialog)
provide('toggleRewardDialog', toggleRewardDialog)
provide('toggleRewardRecordDialog', toggleRewardRecordDialog)
provide('toggleLotteryRecordDialog', toggleLotteryRecordDialog)

const getLotteryCommonConfig = async () => {
  const res = await CnyActApi.getCommonConfig()
  // debugger
  if (res.isActivityEnd) {
    state.actTimeDialog.data.type = 'ended'
    state.actTimeDialog.visible = true
  } else if (!res.isActivityStart) {
    state.actTimeDialog.data.type = 'not-start'
    state.actTimeDialog.visible = true
  }
  console.log('getLotteryCommonConfig res', res)
}
getLotteryCommonConfig()

const getUserLotteryDetail = async () => {
  const res = await CnyActApi.getUserDetail()
  globalConfig.totalLotteryCount = res.totalLotteryCount
  globalConfig.usedLotteryCount = res.usedLotteryCount
  globalConfig.accumulateRewardedList = res.accumulateRewardList || []
  if (!res.isReceivedFreeReward) {
    await CnyActApi.receiveFreeReward()
    toggleLotteryRewardDialog(true, { rewards: [LOGIN_REWARD] }, () => {})
  }
  console.log('getUserLotteryDetail res', res)
}

provide('getUserLotteryDetail', getUserLotteryDetail)

const getLotteryDisplayList = async () => {
  const res = await CnyActApi.getLotteryDisplayList()
  console.log('getLotteryDisplayList res', res)
  const displayList = JSON.parse(JSON.stringify(res.displayList))
  displayList.sort((a, b) => a.displayOrder - b.displayOrder)
  globalConfig.displayList = displayList
}
getLotteryDisplayList()

const getAccumulateRewardList = async () => {
  const res = await CnyActApi.getAccumulateRewardList()
  console.log('getAccumulateRewardList res', res)
  const map = {}
  res.rewardList.forEach(item => {
    const value = map[item.accumulateRewardCode]
    if (!value) {
      map[item.accumulateRewardCode] = {
        accumulateRewardCode: item.accumulateRewardCode,
        lotteryTimes: item.needLotteryCount,
        rewarded: 0, // todo 0: 未领取, 1: 已领取
        props: [],
      }
    }
    map[item.accumulateRewardCode].props.push({
      id: item.propId,
      name: item.propName,
      count: item.count,
    })
  })
  const result = []
  Object.values(map).forEach(item => {
    result.push(item)
  })
  result.sort((a, b) => a.needLotteryCount - b.needLotteryCount)
  globalConfig.accumulateRewardList = result
}
getAccumulateRewardList()

watch(() => store.state.cpUserInfo, () => {
  if (store.state.cpUserInfo.cpUserId && store.state.cpUserInfo.token) {
    getUserLotteryDetail()
  } else {
    globalConfig.totalLotteryCount = 0
    globalConfig.usedLotteryCount = 0
    globalConfig.accumulateRewardedList = []
  }
}, {
  immediate: true,
  deep: true
})

onMounted(() => {
  const handleVisibilityChange = () => {
    if (!document.hidden) {
      if (store.state.cpUserInfo.token) {
        getUserLotteryDetail()
      }
    }
  }
  document.addEventListener('visibilitychange', handleVisibilityChange)
  // 组件卸载时移除监听器
  onUnmounted(() => {
    document.removeEventListener('visibilitychange', handleVisibilityChange)
  })
})
</script>

<style src="./pc_style.less" lang="less" scoped></style>
<style src="./mobile_style.less" lang="less" scoped></style>